document.querySelector('#Details-menu-drawer-container summary')?.addEventListener('click', function () {
  setTimeout(() => {
    document.querySelectorAll(".menu-drawer__menu-item").forEach((link) => {
      const text = link.textContent.trim();

      if (text.includes("Jumbo Sizes")) {
        if (link.querySelector(".menu-label-tag")) return;

        const saveLabel = document.createElement("span");
        saveLabel.textContent = " Save up to 20%";
        saveLabel.classList.add("menu-label-tag");

        link.appendChild(saveLabel);
      }
    });
  }, 50);
});
